import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Zuivelvrij',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Pittig',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Veganistisch',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Glutenvrij',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetarisch',
};
